import { FaFacebookF, FaInstagramSquare, FaLinkedinIn } from "react-icons/fa";
import img from "../../../../../assets/images/Datacode_white_logo.png";

const QuizBoardLandingPageFooter = () => {
  return (
    <footer className="text-white pt-5 QuizBoardLandingPageFooter">
      <div className="container">
        {/* Top Section */}
        <div className="row g-4">
          {/* Logo + Tagline */}
          <div className="col-sm-12 col-md-4 d-flex flex-column align-items-start">
            <img
              src={img}
              alt="Datacode Logo"
              width={200}
              height={100}
              className="img-fluid mb-2"
            />
            <p className="text-white" style={{ fontSize: "16px" }}>
              Empowering learners with interactive quizzes and comprehensive learning tools.
            </p>
          </div>

          {/* COMPANY */}
          <div className="col-sm-12 col-md-2">
            <h5 className="text-white fw-bold">COMPANY</h5>
            <ul className="list-unstyled mt-2">
              <li className="mb-2">Help Center</li>
              <li className="mb-2">Information for Candidates</li>
              <li className="mb-2">Sitemap</li>
              <li className="mb-2">Legal Stuff</li>
            </ul>
          </div>

          {/* RESOURCES */}
          <div className="col-sm-12 col-md-3">
            <h5 className="text-white fw-bold">RESOURCES</h5>
            <ul className="list-unstyled mt-2">
              <li className="mb-2">
                Careers{" "}
                <span className="bg-primary text-white px-2 py-1 rounded-pill">
                  Hiring!
                </span>
              </li>
              <li className="mb-2">ROI Calculator</li>
              <li className="mb-2">Blog</li>
              <li className="mb-2">Privacy Policy</li>
              <li className="mb-2">Contact</li>
            </ul>
          </div>

          {/* CONNECT */}
          <div className="col-sm-12 col-md-3">
            <h5 className="text-white fw-bold">CONNECT</h5>
            <div className="d-flex gap-3 mt-2">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white fs-5"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white fs-5"
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white fs-5"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </div>

        {/* Horizontal line */}
        <hr className="my-4 border-secondary" />

        {/* Bottom Section */}
        <div className="row align-items-center pb-4">
          <div className="col-sm-12 col-md-6 mb-2 mb-md-0 ">
            <span className="text-white">© Datacode 2025. All rights reserved.</span>
          </div>
          <div className="col-sm-12 col-md-6 d-flex justify-content-md-end align-items-center gap-4">
            <a href="#" className="text-white text-decoration-none">
              Terms
            </a>
            <a href="#" className="text-white text-decoration-none">
              Privacy
            </a>
            <a href="#" className="text-white text-decoration-none">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default QuizBoardLandingPageFooter;
